import TeamcityLogo from '@jetbrains/logos/teamcity/teamcity.svg'
import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import classNames from 'classnames'
import {memo} from 'react'

import BuildLineLayout from '../../../containers/BuildLineLayout'
import BuildsFetcher from '../../../containers/BuildsFetcher'
import {base_uri} from '../../../types/BS_types'
import Builds from '../Builds/Builds.container'
import IconButton from '../IconButton/IconButton'

import styles from './BuildsTvMode.css'

type Props = {
  locator: string | null
  title?: string | null
  showLogo: boolean
  showDropDowns: boolean
  showExactStartDate: boolean
  updatePeriod: number
}

function BuildsTvMode({
  locator,
  title,
  showLogo,
  showDropDowns,
  showExactStartDate,
  updatePeriod,
}: Props) {
  const classes = classNames(styles.buildsTvMode, {
    [styles.hideDropDowns]: !showDropDowns,
  })

  return (
    <div className={classes}>
      <div className={styles.title}>
        {showLogo && (
          <IconButton
            title="TeamCity"
            className={styles.titleIcon}
            icon={TeamcityLogo}
            href={base_uri}
          />
        )}
        {title != null && <H1 className={styles.titleText}>{title}</H1>}
      </div>
      <BuildsFetcher locator={locator} updatePeriod={updatePeriod} withQueued withRunning>
        <BuildLineLayout showExactDuration={showExactStartDate} showPath={false}>
          <Builds withLoader />
        </BuildLineLayout>
      </BuildsFetcher>
    </div>
  )
}

export default memo(BuildsTvMode)
